import { createContext, useContext } from "react";
import type { PortalApi } from "./api";
import type { SesionPortal } from "@/reclutamiento/tipos";

export type PortalCtx = {
  api: PortalApi;
  sesion: SesionPortal;
  /** «Ver como el cliente»: nada se puede cambiar. */
  soloLectura: boolean;
  /** Candado de pago del periodo. */
  bloqueado: boolean;
  salir: () => void;
};

export const Ctx = createContext<PortalCtx | null>(null);

export function usePortal(): PortalCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error("usePortal fuera del portal");
  return c;
}

export const AVISO_SOLO_LECTURA = "Estás viendo como el cliente: aquí no se puede cambiar nada.";
